import React, { useState } from 'react';
import { Button, MenuItem } from 'react-bootstrap';
import AuthorizedAction from '../AuthorizedAction.js';
import CustomizeEmailTemplateModal from '../change-insights/CustomizeEmailTemplateModal/index.jsx';
import MailIcon from '../icons/MailIcon.jsx';
import MailWhiteIcon from '../icons/MailWhiteIcon.jsx';

const SendFeedbackModal = ({
  initiative,
  type,
  textButton,
  survey,
  loading,
  isCanManage,
  initiativeType,
  handleClickSendFeedbackForm,
  handleUpdateEmailSetting,
}) => {
  const [showCustomizeEmailModal, setShowCustomizeEmailModal] = useState(false);

  return (
    <React.Fragment>
      <AuthorizedAction action="update" subject={`${initiativeType}Initiative`}>
        {type === 'link' ? (
          <MenuItem
            onClick={() => setShowCustomizeEmailModal(true)}
            disabled={loading}
          >
            <span className="flex">
              <MailIcon />
              <span>&nbsp;{textButton}</span>
            </span>
          </MenuItem>
        ) : (
          <Button
            bsStyle="primary"
            className="flex"
            onClick={() => setShowCustomizeEmailModal(true)}
            disabled={loading || !isCanManage}
          >
            <MailWhiteIcon />
            <span className="m-l-4">
              {loading ? 'Sending' : 'Send Via Email'}
            </span>
          </Button>
        )}
      </AuthorizedAction>
      {survey ? (
        <CustomizeEmailTemplateModal
          initiative={initiative}
          loading={loading}
          emailSettings={survey.emailSettings}
          showModal={showCustomizeEmailModal}
          handleClose={() => {
            setShowCustomizeEmailModal(false);
          }}
          handleUpdateEmailSetting={handleUpdateEmailSetting}
          handleClickSendFeedbackForm={handleClickSendFeedbackForm}
        />
      ) : null}
    </React.Fragment>
  );
};

export default SendFeedbackModal;
